import { BufferGeometry, Points, PointsMaterial, Vector3 } from 'three';
import { PLYLoader } from 'three/examples/jsm/loaders/PLYLoader';

import { WebApi } from '../../../../../services/web-api';
import { CloudFrontSigner } from '../../../../../utils/cloud-front-signer/cloud-front-signer';
import { Coordinates } from '../../../../../viewer/utilities/math-helpers';

async function loadSparsePointCloud(signer: CloudFrontSigner, origo: Vector3): Promise<Points> {
  const referenceEnuUrl = signer.getSignedRequest('opensfm/reference_enu.json');

  const signedRequest = signer.getSignedRequest('opensfm/reconstruction.ply');
  const loader = new PLYLoader();
  // Ensures we get the latest sparse point cloud every time.
  loader.setRequestHeader({
    'Cache-Control': 'no-cache',
  });

  // Ensures we get the latest reference lla every time. (this contains info about the offset)
  const text = await WebApi.fetchS3DataAsText(referenceEnuUrl, { cacheControl: 'no-cache' });
  const referenceEnu = JSON.parse(text) as Coordinates;
  const diff = new Vector3(referenceEnu.easting, referenceEnu.northing, referenceEnu.height).sub(
    origo,
  );

  return new Promise((resolve, reject) => {
    loader.load(
      signedRequest,
      (geometry: BufferGeometry) => {
        geometry.computeBoundingSphere();

        const ply = new Points(
          geometry,
          new PointsMaterial({
            vertexColors: true,
            sizeAttenuation: false,
            size: 4.0,
          }),
        );

        // Adjust the sparse cloud with the diff.
        ply.position.copy(diff);

        resolve(ply);
      },
      undefined,
      (error) => {
        reject(error);
      },
    );
  });
}

export const odmDataLoaders = {
  loadSparsePointCloud,
};
